import { render, staticRenderFns } from "./newsCase.vue?vue&type=template&id=7356fa20&"
import script from "./newsCase.vue?vue&type=script&lang=js&"
export * from "./newsCase.vue?vue&type=script&lang=js&"
import style0 from "./newsCase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports